import { render } from "./SuccessBanner.vue?vue&type=template&id=2f477d30"
import script from "./SuccessBanner.vue?vue&type=script&lang=js"
export * from "./SuccessBanner.vue?vue&type=script&lang=js"

import "./SuccessBanner.vue?vue&type=style&index=0&id=2f477d30&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__